<script>
    import { createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
    import { t } from "../../i18n";

    export let error = "";

    let dispatch = createEventDispatcher();
    let canTryAgain = false;

    setTimeout(()=>canTryAgain = true, 1000);

</script>

<div class="card-body widget-chat-container widget-chat-scroll" style="overflow:auto;">
    <div class="chat-content">

        <div class="badge badge-pill badge-light-secondary my-1">
            {error}
        </div>

        <div>
            {#if canTryAgain}
                <button class="btn btn-danger" on:click={()=>dispatch('retry')} in:fade>{$t('chat.try_again')}</button>
            {/if}
        </div>


    </div>
</div>